import script from "./folderChoose.vue?vue&type=script&setup=true&lang=js"
export * from "./folderChoose.vue?vue&type=script&setup=true&lang=js"

import "./folderChoose.vue?vue&type=style&index=0&id=5347fb49&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5347fb49"]])

export default __exports__